// extracted by mini-css-extract-plugin
module.exports = {"item":"TodoItem_item__2AYnM","checkbox":"TodoItem_checkbox__1iWvm","textInput":"TodoItem_textInput__2oFOI"};